<template>
    <div style="padding: 20px 10px 0 0;">
        <el-dialog :title="'添加值班经理'" :visible.sync="show" width="500px" :close-on-click-modal="false"
            :close-on-press-escape="false">
            <el-form ref="form" label-width="80px">
                <el-form-item label="用户名称">
                    <el-select v-model="userIds" multiple filterable placeholder="请选择用户" style="width:100%">
                        <el-option v-for="s in userList" :label="s.user_name" :value="s.user_id"></el-option>
                    </el-select>
                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="show = false">取 消</el-button>
                <el-button type="primary" @click="ok">确 定</el-button>
            </span>
        </el-dialog>
        <div class="bottom10 flex sb">
            <div class="flex y">
                <!-- 	<span>管理员姓名</span> -->
                <el-form :inline="true">
                    <el-form-item label="用户名">
                        <el-input class="left10 right10" v-model="userName" placeholder="请输入用户名" style="width: 150px;"
                            clearable></el-input>
                    </el-form-item>
                    <el-form-item label="手机号">
                        <el-input class="left10 right10" v-model="phonenumber" placeholder="请输入手机号"
                            style="width: 150px;" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="getAll">搜索</el-button>
                        <el-button type="primary" @click="addRow">新增</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <el-table :data="data" style="width: 100%" border>
            <el-table-column prop="userName" label="用户名">
                <template slot-scope="{row}">
                    {{ row.userName ? row.userName : '未完善' }}
                </template>
            </el-table-column>
            <el-table-column prop="nickName" label="昵称">
                <template slot-scope="{row}">
                    {{ row.nickName ? row.nickName : '未完善' }}
                </template>
            </el-table-column>
            <el-table-column prop="sex" label="性别">
                <template slot-scope="{row}">
                    {{ row.sex == '0' ? '男' : '女' }}
                </template>
            </el-table-column>
            <el-table-column prop="phonenumber" label="手机号">
                <template slot-scope="{row}">
                    {{ row.phonenumber ? row.phonenumber : '未完善' }}
                </template>
            </el-table-column>
            <!-- <el-table-column prop="roleName" label="角色">
				<template slot-scope="{row}">
					{{ row.roleName ? row.roleName : '未完善' }}
				</template>
			</el-table-column> -->
            <!-- <el-table-column prop="postName" label="岗位">
				<template slot-scope="{row}">
					{{ row.postName ? row.postName : '未完善' }}
				</template>
			</el-table-column> -->
            <el-table-column prop="deptName" label="部门">
                <template slot-scope="{row}">
                    {{ row.deptName ? row.deptName : '未完善' }}
                </template>
            </el-table-column>
            <!-- <el-table-column prop="createTime" label="创建时间">
				<template slot-scope="{row}">
					{{ setTime(row.createTime) }}
				</template>
			</el-table-column> -->
            <el-table-column prop="createTime" label="操作">
                <template slot-scope="{row}">
                    <el-button type="text" @click="delRow(row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination v-if="totalNum > 0" background :page-size="pageSize" layout="total, prev, pager, next,sizes"
            @current-change="handleCurrentChange" :total="totalNum" @size-change="handleSizeChange" />
    </div>
</template>

<script>
export default {
    data() {
        return {
            userList: [],
            totalNum: 0,
            userIds: [],
            form: {
                userId: "",
            },
            show: false,
            pageNum: 1, //当前页
            pageSize: 10, //页大小
            userName: '',
            phonenumber: '',
            data: [], //表格数据
        }
    },
    created() {
        this.getAll()
        this.getUser()
    },
    methods: {
        getUser() {
            this.$http.get("/api/safe/userManager/queryUser").then(res => {
                this.userList = res.data.data
            })
        },
        // 分页
        // 当前页
        handleCurrentChange(val) {
            this.pageNum = val;
            this.getAll();
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getAll();
        },
        ok() {
            if (this.userIds.length == 0) {
                this.$message.error("请选择用户")
                return;
            }
            this.form.userId = this.userIds.toString();
            this.$http.post("/api/safe/userManager/addManager?userId=" + this.form.userId, {}).then(res => {
                console.log(res)
                if (res.data.code == 200) {
                    this.$message.success(res.data.msg);
                    this.show = false
                    this.getAll()
                } else {
                    this.$message.error(res.data.msg)
                }

            })
        },
        getAll() { //获取表格分页数据
            this.$http.post(`/api/safe/userManager/list`, {
                rows: this.pageSize,
                page: this.pageNum,
                userName: this.userName,
                phone: this.phonenumber,
            }).then(res => {
                this.data = res.data.data.items
                this.totalNum = res.data.data.totalNum
            })
        },
        addRow() {
            this.form.userId = "";
            this.userIds = [];
            this.show = true
        },
        delRow(obj) { //删除被点击
            console.log(obj)
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.delete(`/api/safe/userManager/delete?id=${obj.userId}`, {}).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success(res.data.msg)
                        this.getAll()
                    } else {
                        this.$message.error(res.data.msg)
                    }

                })
            }).catch(() => { });
        }
    },

}
</script>

<style>

</style>
